import { render, staticRenderFns } from "./ucenter.vue?vue&type=template&id=8254d202&scoped=true"
import script from "./ucenter.vue?vue&type=script&lang=js"
export * from "./ucenter.vue?vue&type=script&lang=js"
import style0 from "./ucenter.vue?vue&type=style&index=0&id=8254d202&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8254d202",
  null
  
)

export default component.exports